import { magicRatioNum } from "./values.config";

export const orientationCalc = (size, orientation) => {
  let width = size.width;
  let height = size.height;
  if (orientation === "landscape") {
    return {
      width: width >= height ? height : width,
      height: width >= height ? width : height,
    };
  } else {
    return {
      width: width >= height ? width : height,
      height: width >= height ? height : width,
    };
  }
};
